import Swiper from "swiper";
import {Navigation, Pagination} from "swiper/modules";

const initProductOrServiceSections = () => {
    [...document.querySelectorAll('.product-or-service-section')]
        .filter(item => item.dataset.init !== 'true')
        .forEach((item) => initProductOrServiceSection(item));
};

const initProductOrServiceSection = (section) => {
    section.dataset.init = true;
    const slider = section.querySelector('.service-items');
    const swiper = new Swiper(slider, {
        modules: [Navigation, Pagination],
        slidesPerView: 3,
        spaceBetween: 16,
        autoHeight: false,
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            240: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            },
        },
    });
    section.addEventListener('click', e => {
        const prevButton = e.target.closest('.swiper-button-prev');
        if(prevButton) {
            swiper.slidePrev();
            return;
        }
        const nextButton = e.target.closest('.swiper-button-next');
        if(nextButton) {
            swiper.slideNext();
            return;
        }
    })
};

export { initProductOrServiceSections };